/**
* 基础菜单 商品基础信息管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_name" placeholder="输入商品名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="输入商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.brand_name" placeholder="输入商品品牌" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.standard_code" placeholder="输入松佰标准编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.is_not_set" placeholder="请选择是否设置商品详情" clearable>
          <el-option label="否" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.audit_status" placeholder="请选择审核状态" clearable>
          <el-option v-for="(auditStatus,index) in auditStatusList" :key="auditStatus.value" :label="auditStatus.name"
                     :value="auditStatus.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.isPic" placeholder="商品图片/商品证件图片是否为空" clearable>
          <el-option label="为空" value="1"></el-option>
          <el-option label="不为空" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <!-- <el-button size="small" type="primary" @click="addProductdialog" class="add-button">新增</el-button> -->
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="editProductdialog" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delProduct">删除</el-button>
        <el-button size="small" type="primary" plain @click="editClassify">修改分类</el-button>
        <!-- <el-button size="small" type="success" plain @click="excelData" v-if="isshow">松佰牙科ERP数据导入</el-button> -->
        <!-- <el-button size="small" type="primary" plain @click="excelCopy">复制商品信息</el-button> -->
        <!-- <el-button size="small" type="warning" plain @click="zation" v-if="songbai_system==1">子公司商品信息同步</el-button> -->
        <!-- <el-button size="small" type="warning" plain @click="batch">批量导入基础信息</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 585px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border class="list-table"
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          fixed
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="product_name" fixed label="商品名称" min-width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_code" fixed label="商品编码" width="120" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div plain style="color: #F56C6C" v-if="scope.row.isPic=='1'">
              {{scope.row.product_code}}
            </div>
            <div plain v-else>
              {{scope.row.product_code}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sortname3" fixed label="商品分类" width="150" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div class="over_text_1" v-if="scope.row.sortname1">
              {{scope.row.sortname1+'-'+scope.row.sortname2+'-'+scope.row.sortname3}}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="brand_name" fixed label="品牌" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="audit_status" fixed label="审核状态" width="85">
          <template slot-scope="scope">
            <div v-if="scope.row.audit_status==260">审核中</div>
            <div v-else-if="scope.row.audit_status==261">审核通过</div>
            <div v-else-if="scope.row.audit_status==262">审核不通过</div>
            <div v-else>未提交</div>
          </template>
        </el-table-column>
        <el-table-column prop="audit_comment" fixed label="审核意见" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" fixed label="创建时间" width="135">
          <template slot-scope="scope">
            <div>{{scope.row.create_time|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="standard_code" label="松佰标准编码" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="reg_name" label="注册证名称" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="standard" label="产品标准" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="productTypeName" label="产品类型" width="120">
        </el-table-column>
        <el-table-column prop="liquid" label="是否为粉末液体" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.liquid">是</div>
            <div v-else-if="scope.row.liquid==0">否</div>
            <div></div>
          </template>
        </el-table-column>
        <el-table-column prop="product_enterprise" label="生产企业" width="270" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="model" label="型号规格" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="pack_unit" label="包装方式" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="med_code" label="医保码" width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="weight_unit" label="重量单位" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.weight_unit==41">千克(kg)</div>
            <div v-else>克(g)</div>
            <div></div>
          </template>
        </el-table-column>
        <el-table-column prop="product_expire" label="有效期" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <!--      <el-table-column prop="need_upt_cert" label="是否需要换注册证" width="130">-->
        <!--        <template slot-scope="scope">-->
        <!--          <div v-if="scope.row.need_upt_cert">是</div>-->
        <!--          <div v-else-if="scope.row.need_upt_cert==0">否</div>-->
        <!--          <div v-else></div>-->
        <!--        </template>-->
        <!--      </el-table-column>-->
        <!--      <el-table-column prop="new_cert" label="新注册证号" width="100">-->
        <!--      </el-table-column>-->
        <el-table-column align="left" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="audit(scope.row.id)"
                       v-if="scope.row.audit_status!=260&&scope.row.audit_status!=261"
            >提交审核
            </el-button>
            <el-button type="primary" size="mini"
                       @click="lookdetail(scope.row.id,scope.row.sortname1,scope.row.sortname2,scope.row.sortname3,scope.row.brand_name)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 基础信息新增 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle" :before-close="handleClose"
               :visible.sync="productDialogVisible"
               width="45%"
               center>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="基本信息" name="first">
          <el-form label-width="150px" :model="productForm" :rules="rules" ref="productForm" class="productForm">
            <el-form-item label="商品名称" prop="product_name">
              <el-input size="small" v-model="productForm.product_name" auto-complete="off" clearable maxlength="100"
                        placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="商品编号" prop="product_code">
              <el-input type="text" size="small" v-model="productForm.product_code" auto-complete="off" clearable
                        maxlength="50" onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')"
                        placeholder="请输入商品编号"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">货号-公司名缩写</div>
            </el-form-item>
            <el-form-item label="商品分类" prop="sort_id">
              <el-cascader :options="productOptions" :props="defaultParams" v-model="productForm.sort_id"
                           @change="productSortChange(productForm.sort_id)" clearable></el-cascader>
            </el-form-item>
            <el-form-item label="商品品牌" prop="brand_id">
              <el-select v-model="productForm.brand_id" placeholder="请选择商品品牌" clearable>
                <el-option v-for="(brand,index) in ProductBrandList" :key="brand.id" :label="brand.name"
                           :value="brand.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品类型" prop="product_type">
              <el-select v-model="productForm.product_type" placeholder="请选择商品类型" clearable>
                <el-option v-for="type in ProductType" :key="type.code" :label="type.name"
                           :value="type.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否为粉末液体" prop="liquid">
              <el-select v-model="productForm.liquid" placeholder="请选择是否为粉末液体" clearable>
                <el-option v-for="item in liquidList" :key="item.value" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否支持易燃易爆" prop="is_iae">
              <el-select v-model="productForm.is_iae" placeholder="请选择是否支持易燃易爆" clearable>
                <el-option v-for="item in iaeList" :key="item.value" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="有效期" prop="product_expire">
              <el-input type="text" size="small" v-model="productForm.product_expire" auto-complete="off" clearable
                        maxlength="20"
                        placeholder="请输入有效期"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">示例：1年、3年或永久</div>
            </el-form-item>
            <el-form-item label="储运条件" prop="storage_cond">
              <el-select v-model="productForm.storage_cond" placeholder="请选择储运条件" clearable>
                <el-option label="常温" value="常温"></el-option>
                <el-option label="冷藏" value="冷藏"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="型号规格" prop="model">
              <el-input size="small" v-model="productForm.model" auto-complete="off" clearable maxlength="100"
                        placeholder="请输入型号规格"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">示例：液体40g、21mm,F1 黄色</div>
            </el-form-item>
            <el-form-item label="重量单位" prop="weight_unit">
              <el-select v-model="productForm.weight_unit" placeholder="请选择重量单位" clearable>
                <el-option v-for="item in weightUnitList" :key="item.value" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包装单位" prop="pack_unit">
              <el-input type="text" size="small" v-model="productForm.pack_unit" auto-complete="off" min="1" clearable maxlength="10"
                        placeholder="请输入包装单位"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">示例：罐、支、把</div>
            </el-form-item>
            <el-form-item label="注册证名称" prop="reg_name">
              <el-input type="text" size="small" v-model="productForm.reg_name" auto-complete="off" clearable
                        maxlength="100"
                        placeholder="请输入注册证名称"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">注册证上的产品名称</div>
            </el-form-item>
            <el-form-item label="注册证号" prop="reg_cert">
              <el-input type="text" size="small" v-model="productForm.reg_cert" auto-complete="off" clearable
                        maxlength="100"
                        placeholder="请输入注册证号"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">注册证上的注册证编号</div>
            </el-form-item>
            <el-form-item label="注册证有效期" prop="reg_cert_expires">
              <el-date-picker
                v-model="productForm.reg_cert_expires"
                type="date"
                placeholder="请选择注册证有效期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="产品标准" prop="standard">
              <el-input type="text" size="small" v-model="productForm.standard" auto-complete="off" clearable
                        maxlength="100"
                        placeholder="请输入产品标准"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">产品外包装上的产品标准或注册证号或执行标准，非医疗器械请填写相应国标标准</div>
            </el-form-item>
            <el-form-item label="医械类别" prop="machine_type" v-if="productForm.product_type!='1153'">
              <el-input type="text" size="small" v-model="productForm.machine_type" auto-complete="off" clearable
                        maxlength="30"
                        placeholder="请输入医械类别"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">示例：I、II</div>
            </el-form-item>
            <el-form-item label="是否7天无理由退货" prop="days7">
              <el-select v-model="productForm.days7" placeholder="请选择是否7天无理由退货" clearable>
                <el-option v-for="item in days7List" :key="item.value" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="可换货期限 (天)" prop="change_days">
              <el-input type="text" size="small" v-model="productForm.change_days" auto-complete="off"
                        clearable
                        maxlength="4"
                        placeholder="请输入可换货期限 "></el-input>
              <span>天</span>
              <div class="lineHeight20 f12 colorA8ABB2">示例：7、15</div>
            </el-form-item>
            <el-form-item label="生产企业" prop="product_enterprise">
              <el-input size="small" v-model="productForm.product_enterprise" auto-complete="off" clearable
                        maxlength="50"
                        placeholder="请输入生产企业"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">国产产品：外包装生产企业名称；进口产品：注册证注册人名称（英文）</div>
            </el-form-item>
            <el-form-item label="禁忌症" prop="avoid">
              <el-input size="small" v-model="productForm.avoid" auto-complete="off" clearable maxlength="50"
                        placeholder="请输入禁忌症"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">示例：酒后禁用</div>
            </el-form-item>
            <el-form-item label="医械类号" prop="machine_sort_no" v-if="productForm.product_type!='1153'">
              <el-input type="text" size="small" v-model="productForm.machine_sort_no" auto-complete="off" clearable
                        maxlength="40"
                        placeholder="请输入医械类号"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">示例：6863、新分类17</div>
            </el-form-item>
            <el-form-item label="包装方式" prop="pack">
              <el-input type="text" size="small" v-model="productForm.pack" auto-complete="off" min="1" clearable
                        maxlength="30"
                        placeholder="请输入包装方式"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">示例：500g/包,12包/件</div>
            </el-form-item>
<!--            <el-form-item label="销售/使用单位比" prop="sale_use_rate">-->
<!--              <el-input type="text" size="small" v-model="productForm.sale_use_rate" auto-complete="off" min="1" clearable-->
<!--                        maxlength="9"-->
<!--                        placeholder="请输入销售/使用单位比"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="适用范围" prop="scope">
              <el-input size="small" v-model="productForm.scope" auto-complete="off" clearable maxlength="60"
                        placeholder="请输入适用范围"></el-input>
              <div class="lineHeight20 f12 colorA8ABB2">示例：用于制取牙齿及口腔软硬组织的印模材料。</div>
            </el-form-item>
            <el-form-item label="医保码" prop="med_code">
              <el-input type="text" size="small" v-model="productForm.med_code" auto-complete="off" clearable
                        maxlength="50"
                        placeholder="请输入医保码"></el-input>
            </el-form-item>
            <el-form-item label="松佰标准编码" prop="standard_code">
              <el-input type="text" size="small" v-model="productForm.standard_code" auto-complete="off" clearable
                        maxlength="45"
                        placeholder="请输入松佰标准编码"></el-input>
            </el-form-item>
            <el-form-item :label="attr.attr_name" prop="attr_id" v-for="(attr,index) in attrValueList" :key="index">
              <el-input type="text" size="small" v-model="attr.attr_value" auto-complete="off" clearable maxlength="45"
                        :placeholder="'请输入'+attr.attr_name"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="商品图片/视频/证件" name="second">
          <div>
            <div><h3 class="inline_block">商品图片</h3><span class="img-tips">（图片尺寸2000px*2000px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式）</span>
            </div>
            <el-upload ref="upload1"
                       action="#"
                       list-type="picture-card"
                       :multiple="true"
                       :http-request="uploadFile"
                       :before-upload="beforeProductUpload"
                       :file-list="productImgFilesList"
                       :on-remove="handleProductRemove"
                       :on-preview="handlePictureCardPreview">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="pictureDialogVisible" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div v-if="isShowTip" style="color: #F31B1B">{{isShowTipMessage}}</div>
          <div>
            <div><h3 class="inline_block">商品视频</h3><span
              class="img-tips">（单个视频大小不得超过10M，仅支持mp4格式，上传完成后可自行上传视频缩略图）</span></div>
            <div class="video-box clearfix">
              <div class="float-left" v-for="(video,index) in productVideoUrl" :key="index">
                <div class="video-list-box" @mouseenter="handleMouseEnter(video.isShowButton,index)"
                     @mouseleave="handleMouseLeave(video.isShowButton,index)">
                  <div class="img-mask" v-show="video.isShowButton">
                    <div class="inline_block">
                      <el-upload
                        action="#"
                        :show-file-list="false"
                        :http-request="uploadFile"
                        :before-upload="uploadDefaultUpload"
                      >
                        <i class="el-icon-folder-add"></i>
                      </el-upload>
                    </div>
                    <i class="el-icon-delete" @click="delVideo(index)"></i>
                  </div>
                  <el-image class="inline_block video-default-img"
                            :src="video.img_url?video.img_url:defaultVideoImg">
                  </el-image>
                </div>
              </div>
              <el-upload list-type="picture-card" :http-request="uploadFile" ref="upload2"
                         v-loading.fullscreen.Tock="videoloading"
                         element-loading-text="拼命上传中" element-loading-spinner="el-icon-loading"
                         element-loading-background="rgba(0,0,0,0.8)"
                         class="float-left avatar-uploader el-upload--text" action="#" :show-file-list="false"
                         :file-list="productVideoFilesList"
                         :before-upload="beforeUploadVideo">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div v-if="productVideoUrl.length" style="color: rgba(64, 158, 255, 0.7);">
              tips：视频上传完成，请继续上传视频缩略图，图片尺寸为500*500px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式.
            </div>
          </div>
          <div>
            <div><h3 class="inline_block">商品证件图片</h3><span class="img-tips">（单张图片大小不得超过1M，仅支持jpg、jpeg、png格式）</span>
            </div>
            <el-upload :multiple="true"
                       action="#" ref="upload3"
                       list-type="picture-card"
                       :http-request="uploadFile"
                       :before-upload="beforeProductCredentialUpload"
                       :file-list="productCredentialImgFilesList"
                       :on-remove="handleCredentialRemove"
                       :on-preview="handlePictureCardPreviewB">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="pictureDialogVisibleB" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div v-if="isShowTip1" style="color: #F31B1B">{{isShowTipMessage}}</div>
        </el-tab-pane>
        <el-tab-pane label="商品介绍" name="third">
          <div>
            <div><h3 class="inline_block">商品介绍图片-PC版</h3><span class="img-tips">（图片宽度1200px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式）</span>
            </div>
            <el-upload :multiple="true"
                       action="#" ref="upload4"
                       list-type="picture-card"
                       :http-request="uploadFile"
                       :before-upload="beforeProductIntroducePCUpload"
                       :file-list="productIntroducePCImgFilesList"
                       :on-remove="handleIntroducePCRemove"
                       :on-preview="handlePictureCardPreviewC">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="pictureDialogVisibleC" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div v-if="isShowTip2" style="color: #F31B1B">{{isShowTipMessage}}</div>
          <div>
            <div><h3 class="inline_block">使用说明图片-PC版</h3><span class="img-tips">（图片宽度1200px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式）</span>
            </div>
            <el-upload :multiple="true"
                       action="#" ref="upload5"
                       list-type="picture-card"
                       :http-request="uploadFile"
                       :before-upload="beforeProductInstructionsPCUpload"
                       :file-list="productInstructionsPCImgFilesList"
                       :on-remove="handleInstructionsPCRemove"
                       :on-preview="handlePictureCardPreviewD">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="pictureDialogVisibleD" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div v-if="isShowTip3" style="color: #F31B1B">{{isShowTipMessage}}</div>
          <div>
            <div><h3 class="inline_block">商品介绍图片-移动版</h3><span class="img-tips">（图片宽度790px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式）</span>
            </div>
            <el-upload :multiple="true"
                       action="#" ref="upload6"
                       list-type="picture-card"
                       :http-request="uploadFile"
                       :before-upload="beforeProductIntroduceAPPUpload"
                       :file-list="productIntroduceAPPImgFilesList"
                       :on-remove="handleIntroduceAPPRemove"
                       :on-preview="handlePictureCardPreviewE">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="pictureDialogVisibleE" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div v-if="isShowTip4" style="color: #F31B1B">{{isShowTipMessage}}</div>
          <div>
            <div><h3 class="inline_block">使用说明图片-移动版</h3><span class="img-tips">（图片宽度790px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式）</span>
            </div>
            <el-upload :multiple="true"
                       action="#" ref="upload7"
                       list-type="picture-card"
                       :http-request="uploadFile"
                       :before-upload="beforeProductInstructionsAPPUpload"
                       :file-list="productInstructionsAPPImgFilesList"
                       :on-remove="handleInstructionsAPPRemove"
                       :on-preview="handlePictureCardPreviewF">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="pictureDialogVisibleF" :modal="false">
              <img width="100%" height="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div v-if="isShowTip5" style="color: #F31B1B">{{isShowTipMessage}}</div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">关 闭</el-button>
            <el-button type="primary" @click="sureProductsubmit('productForm')" :disabled="!isCanSubmit">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="修改分类"
               :visible.sync="editSortDialogVisible"
               width="40%"
               center>
      <el-form label-width="120px" :model="sortForm" :rules="sortRules" ref="sortForm" class="sortForm">
        <el-form-item label="商品分类" prop="sort_id">
          <el-cascader :options="productOptions" :props="defaultParams" v-model="sortForm.sort_id"
                       @change="productSortChange(sortForm.sort_id)" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="商品品牌" prop="brand_id">
          <el-select v-model="sortForm.brand_id" placeholder="请选择商品品牌" clearable>
            <el-option v-for="(brand,index) in ProductBrandList" :key="brand.id" :label="brand.name"
                       :value="brand.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="editSortDialogVisible=false">关 闭</el-button>
            <el-button type="primary" @click="sureEditSort()">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="松佰牙科ERP数据导入"
               :visible.sync="excelDataDialogVisible"
               width="60%"
               top="6vh"
               center>
      <el-form :inline="true" :model="excelDataformInline" class="user-search">
        <el-form-item label="">
          <el-input size="small" v-model="excelDataformInline.product_name" placeholder="输入商品名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input size="small" v-model="excelDataformInline.brand" placeholder="输入品牌" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input size="small" v-model="excelDataformInline.standard_code" placeholder="输入松佰标准编码"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="excelDataformInline.status" placeholder="请选择导入状态" clearable>
            <el-option label="未导入" value="0"></el-option>
            <el-option label="已导入" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="excelDataSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <div style="height: 510px;overflow-y: auto">
        <el-table size="small" :data="listExcelData" highlight-current-row v-loading="loading" border
                  @cell-dblclick="cellDbClick" @selection-change="excelhandleSelectionChange"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="商品名称" min-width="160" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="brand_name" label="品牌" min-width="180" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="model" label="型号规格" min-width="180" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="standard_code" label="松佰标准编码" width="200" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="status" label="导入状态" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain v-if="!scope.row.status">
                未导入
              </el-button>
              <el-button type="success" size="mini" v-else>
                已导入
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="excelpageparm" @callFather="excelcallFather"></Pagination>
      <span slot="footer" class="dialog-footer">
            <el-button @click="excelDataDialogVisible=false">关 闭</el-button>
            <el-button type="primary" @click="sureImport()">确认导入</el-button>
      </span>
    </el-dialog>
    <!-- 复制商品信息 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="复制商品信息"
               :visible.sync="editCopeDialogVisible"
               width="40%"
               center>
      <div>
        <p class="f16 color409EFF fw600 mb10">原商品信息</p>
        <div class="pduct">
          <div class="flex_box billing_item mb10">
            <p class="libel f14 color666"><span>商品名称</span></p>
            <span class="f14 color333">{{ product_name }}</span>
          </div>
          <div class="flex_box billing_item">
            <p class="libel f14 color666"><span>商品品牌</span></p>
            <span class="f14 color333">{{ brand_name }}</span>
          </div>
        </div>
      </div>
      <div class="scrollbar mt20" style="max-height: 377px;overflow-y: auto">
          <p class="f16 color409EFF fw600 mb10">新商品信息 <span class="f10 color666 fw400">（除商品编码、型号规格以外，原商品信息（包含图片/视频信息）将会同步至新商品信息中）</span> </p>
          <el-table size="small" :data="ondentData" highlight-current-row v-loading="loading" border
                    element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 20px">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column prop="product_code" label="商品编号" min-width="175">
              <template slot-scope="scope" style="position: relative">
                  <el-input v-model="scope.row.product_code" placeholder="商品编号" maxLength="50"
                            clearable onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')" :class="productcodeIndexList.indexOf(scope.$index)>-1?'redBorder':''"
                  ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="model" label="型号规格" width="270" :show-overflow-tooltip='true'>
              <template slot-scope="scope" style="position: relative">
                  <el-input v-model="scope.row.model"  placeholder="型号规格" maxLength="100" clearable :class="modelIndexList.indexOf(scope.$index)>-1?'readBorder':''"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="danger" plain size="mini" @click.native.prevent="deleteRow(scope.$index, ondentData)"
                           style="width: 80px">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="stions"><el-button type="primary" plain @click="addSpecifications">新增型号规格</el-button></div>
      <div class="mt30" v-if="showValue">
        <div class="flexCenter_box">
          <div class="warin mr5">
              <el-result icon="warning">
              </el-result>
          </div>
          <div class="wari"><p>新增商品编码重复，请核对后再提交！</p></div>
        </div>
      </div>
      <div class="mt30" v-if="lapeValue">
        <div class="flexCenter_box">
          <div class="warin mr5">
              <el-result icon="warning">
              </el-result>
          </div>
          <div class="wari"><p>新增型号规格重复，请核对后再提交！</p></div>
        </div>
      </div>
      <div class="mt30" v-if="emptyValue">
        <div class="flexCenter_box">
          <div class="warin mr5">
              <el-result icon="warning">
              </el-result>
          </div>
          <div class="wari"><p>复制商品信息不能为空，请删除或补充完整后再提交！</p></div>
        </div>
      </div>
      <div class="mt30" v-if="tionsValue">
        <div class="flexCenter_box">
          <div class="warin mr5">
              <el-result icon="warning">
              </el-result>
          </div>
          <div class="wari"><p>新增商品编码不能为空，请删除或补充完整后再提交！</p></div>
        </div>
      </div>
      <div class="mt30" v-if="specValue">
        <div class="flexCenter_box">
          <div class="warin mr5">
              <el-result icon="warning">
              </el-result>
          </div>
          <div class="wari"><p>新增型号规格不能为空，请删除或补充完整后再提交！</p></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="copeMine()">确 定</el-button>
            <el-button @click="editCopeDialogVisible=false">取 消</el-button>
      </span>
    </el-dialog>

<!--    子公司商品信息同步-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="子公司商品信息同步"
               :visible.sync="infoDialogVisible"
               width="60%"
               top="6vh"
               center>
      <!--列表-->
      <div style="height: 510px;overflow-y: auto">
        <el-table size="small" :data="infolistData" highlight-current-row v-loading="loading" border
                  @cell-dblclick="cellDbClick" @selection-change="infoHandleSelectionChange"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="seller_name" label="公司名称" min-width="180" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="sale_name" label="商品销售名称" width="220" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="standard_code" label="松佰标准编码" width="120" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="putaway_status" label="上架状态" width="120">
            <template slot-scope="scope">
              <div plain style="color: #F56C6C" v-if="scope.row.putaway_status=='76'">已下架</div>
              <div plain v-else-if="scope.row.putaway_status=='77'">未上架</div>
              <div plain style="color: #409eff" v-else>已上架</div>
            </template>
          </el-table-column>
          <el-table-column prop="pc_url" label="商城地址" width="220" :show-overflow-tooltip='true'>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="infopageparm" @callFather="infocallFather"></Pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureRonous()">确认同步</el-button>
        <el-button @click="infoDialogVisible=false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 批量导入基础信息 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="批量导入基础信息" :before-close="importHandleClose"
               :visible.sync="importDialogVisible"
               width="40%"
               top="6vh"
               center>
      <div class="zipFile">
        <div style="width: 200px;height: 150px">
          <el-upload :http-request="uploadFile"
                     ref="zipLoad"
                     action="#"
                     :before-upload="beforeUpload"
                     :limit="1"
                     :auto-upload="true">
            <div class="icon-container">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </div>
        <div class="prompt">请在下载的模板中填入基础信息后在此处上传</div>
      </div>
      <div style="text-align: center;margin: 10px 0;">
        <el-button size="small" type="primary" :loading="loading" @click="confirmImport" :disabled="!isCanSubmit">确认导入</el-button>
        <el-button size="small" :loading="loading" @click="download">下载模版</el-button>
      </div>
      <!--列表-->
      <div class="importLog">导入日志</div>
      <div style="height: 300px;overflow-y: auto">
        <el-table size="small" :data="importlistData" highlight-current-row v-loading="loading" border
                  @cell-dblclick="cellDbClick" :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column
            type="index"
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{importpageparm.pageSize * (importpageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="导入时间" width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div>{{scope.row.create_time|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="file_name" label="文件名称" min-width="150" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="status" label="导入结果" width="120" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div plain v-if="scope.row.status=='0'">处理中</div>
              <div plain v-else-if="scope.row.status=='1'">处理成功</div>
              <div plain v-else>处理失败</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" @click="results(scope.row.file_id, scope.row.error_message, scope.row.status, scope.row.total_fail)"
                         v-if="scope.row.status != '0'"
                         style="width: 80px">查看结果
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="importpageparm" @callFather="importFather"></Pagination>
    </el-dialog>

    <!--导入结果-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="导入结果"
               :visible.sync="resultsDialogVisible"
               width="40%"
               top="15vh"
               center>
      <!--列表-->
      <div v-if="importWas">
        <div class="importtion">
          已成功导入<span class="color409EFF">{{ total_success }}</span>条数据，<span class="color409EFF">{{ total_code }}</span>条数据已存在无需重复导入，
          <span class="colorec808d">{{ total_brand }}</span>条数据分类/品牌为空，<span class="colorec808d">{{ total_fail }}</span>条数据导入失败
        </div>
        <div style="height: 300px;overflow-y: auto">
          <el-table size="small" :data="resultslistData" highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{resultspageparm.pageSize * (resultspageparm.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="product_code" label="商品编码" min-width="150" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="product_name" label="商品名称" width="200" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="error_message" label="失败原因" width="200" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <span class="colord9001b">{{ scope.row.error_message }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="resultspageparm" @callFather="resultscallFather"></Pagination>
        <div slot="footer" class="dialog-footer textCenter">
          <el-button type="primary" @click="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
      <div class="textCenter" v-if="totalFail">
        <div class="resultent">已成功导入{{ total_success }}条数据，{{ total_fail }}条数据导入失败</div>
        <div style="margin-top: 20px">
          <el-button type="primary" @click.capture="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
      <div class="textCenter" v-if="importFailed">
        <div class="resultent">{{ errorMessage }}</div>
        <div style="margin-top: 20px">
          <el-button type="primary" @click.capture="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  productInfoList, productTree, productBrand, addProduct, productDetail,
  editProduct, deleteProduct, updateProductSort, submitAudit,
  attrList, erpProductList, erpImportProduct, attrValues,
  copyProduct, erpImportBtn, syncProductList, syncProduct,
  baseinfoExport, logsList, logsDetailList, batchImport, logsDetailListGroup
} from '../../api/basisMG'
  import {param, uploadVideo, uploadImgTmp, getToken} from '../../api/commonMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate, timestampToTime, uploadFile} from "../../utils/util";
  import axios from "axios";

  export default {
    name: 'goodInfo',
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入可换货期限'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        videoloading: false,
        videoloadingB: false,
        showValue: false,
        lapeValue: false,
        emptyValue: false,
        tionsValue: false,
        specValue: false,
        isshow: false,
        dialogTitle: '',
        multiple: true,
        activeName: 'first',//弹窗默认显示第一页
        productDialogVisible: false,//新增商品弹窗
        editSortDialogVisible: false,//修改商品弹窗
        excelDataDialogVisible: false,
        editCopeDialogVisible: false,
        infoDialogVisible: false,
        importDialogVisible: false,
        resultsDialogVisible: false,
        isRewiriteEditor: false,
        dialogVisible: false,
        defaultVideoImg: '/static/img/video.png',
        formInline: {
          page: 1,
          rows: 10,
          need_upt_cert: '',
          is_not_set: '',
          isPic: '',
          product_name: "",
          product_code: "",
          brand_name: "",
          standard_code: "",
          audit_status: ''
        },
        excelDataformInline: {
          page: 1,
          rows: 10,
          product_name: "",
          standard_code: "",
          brand: "",
          status: ''
        },
        productForm: {
          id: '',
          product_name: '',
          product_code: '',
          sort_id: '',
          brand_id: '',
          product_type: '',
          liquid: '',
          product_expire: '',
          is_iae: '',
          model: '',
          storage_cond: '',
          weight_unit: '',
          pack_unit: '',
          reg_name: '',
          reg_cert: '',
          reg_cert_expires: '',
          standard: '',
          machine_type: '',
          scope: '',
          days7: '',
          change_days: '',
          product_enterprise: '',
          avoid: '',
          machine_sort_no: '',
          pack: '',
          med_code: '',
          standard_code: '',
          attr_name: '',
          attr_id: '',
          attr_value: '',
          values: []
        },
        sortForm: {
          sort_id: '',
          brand_id: '',
        },
        // listForm: {
        //   file_url: ''
        // },
        productId: '',
        sortRules: {
          sort_id: [{required: true, message: '请选择商品分类', trigger: 'change'}],
          brand_id: [{required: true, message: '请选择商品品牌', trigger: 'change'}],
        },
        listData: [], //用户数据
        selectTableData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        excelpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        infopageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        importpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        resultspageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        infoFormInline: {
          page: 1,
          rows: 10,
          product_id: ""
        },
        importFormInline: {
          page: 1,
          rows: 10,
          fileId: ""
        },
        summaryFormInline: {
          page: 1,
          rows: 10,
          fileId: ""
        },
        detailsFormInline: {
          fileId: ""
        },
        sale_id: '',
        // rules表单验证
        rules: {
          product_name: [
            {required: true, message: '请输入商品名称', trigger: 'blur'}
          ],
          product_code: [{required: true, message: '请输入商品编号', trigger: 'blur'}],
          sort_id: [{required: true, message: '请选择商品分类', trigger: 'change'}],
          brand_id: [{required: true, message: '请选择商品品牌', trigger: 'change'}],
          product_type: [{required: true, message: '请选择商品类型', trigger: 'change'}],
          liquid: [
            {required: true, message: '请选择是否为粉末液体', trigger: 'change'}
          ],
          product_expire: [{required: true, message: '请输入有效期', trigger: 'blur'}],
          is_iae: [{required: true, message: '请选择是否支持易燃易爆', trigger: 'change'}],
          model: [{required: true, message: '请输入型号规格', trigger: 'change'}],
          storage_cond: [{required: true, message: '请选择储运条件', trigger: 'change'}],
          weight_unit: [
            {required: true, message: '请选择重量单位', trigger: 'change'}
          ],
          pack_unit: [{required: true, message: '请输入包装单位', trigger: 'blur'}],
          reg_name: [{required: true, message: '请输入注册证名称', trigger: 'blur'}],
          reg_cert: [{required: true, message: '请输入注册证号', trigger: 'blur'}],
          reg_cert_expires: [{required: true, message: '请选择注册证有效期', trigger: 'change'}],
          standard: [
            {required: true, message: '请输入产品标准', trigger: 'blur'}
          ],
          machine_type: [{required: true, message: '请输入医械类别', trigger: 'blur'}],
          // scope: [{required: true, message: '请输入适用范围', trigger: 'blur'}],
          days7: [{required: true, message: '请选择是否7天无理由退货', trigger: 'change'}],
          change_days: [{required: true, validator: validateNum, trigger: 'blur'}],
          product_enterprise: [{required: true, message: '请输入生产企业', trigger: 'blur'}],
          avoid: [{required: true, message: '请输入禁忌症', trigger: 'blur'}],
          machine_sort_no: [{required: true, message: '请输入医械类号', trigger: 'blur'}],
          pack: [{required: true, message: '请输入包装方式', trigger: 'blur'}],
          standard_code: [{required: localStorage.getItem('songbai_system')==1?true:false, message: '请输入松佰标准编码', trigger: 'blur'}]
        },
        liquidList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        iaeList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        weightUnitList: [{
          name: '千克(kg)',
          value: 41
        }, {
          name: '克(g)',
          value: 42
        }],
        days7List: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        auditStatusList: [
          {
            name: '未审核',
            value: 10000
          }, {
            name: '审核中',
            value: 260
          }, {
            name: '审核通过',
            value: 261
          }, {
            name: '审核不通过',
            value: 262
          }
        ],
        product_id: '',
        product_name: '',
        brand_name: '',
        foram: {
          image: ''
        },
        labelForm: {
          detail_label_url: ''
        },
        isCanSubmit: true,
        productImageUrl: [],
        productVideoUrl: [],
        videoUrl: '',
        videoUploadPercent: 0,
        progressWidth: 146,
        ProductType: [],
        productOptions: [],
        defaultParams: {
          label: 'text',
          value: 'id',
          children: 'children'
        },
        ProductBrandList: [],
        productCredentialImageUrl: [],//新增商品图片数组
        productIntroducePCImageUrl: [],//新增商品图片数组
        productInstructionsPCImageUrl: [],//新增商品图片数组
        productIntroduceAPPImageUrl: [],//新增商品图片数组
        productInstructionsAPPImageUrl: [],//新增商品图片数组
        productImgFilesList: [],//修改时已有图片的数组
        productVideoFilesList: [],
        productCredentialImgFilesList: [],//修改时已有图片的数组
        productIntroducePCImgFilesList: [],//修改时已有图片的数组
        productInstructionsPCImgFilesList: [],//修改时已有图片的数组
        productIntroduceAPPImgFilesList: [],//修改时已有图片的数组
        productInstructionsAPPImgFilesList: [],//修改时已有图片的数组
        videoDefaultImgIndex: 0,
        isShowTip: false,
        isShowTip1: false,
        isShowTip2: false,
        isShowTip3: false,
        isShowTip4: false,
        isShowTip5: false,
        isShowTipMessage: '',
        productAttrs: [],
        productName: '',
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        small: true,
        selectedruleName: '',
        listExcelData: [],
        selectExcelTableData: [],
        infoSelectTableData: [],
        attrValueList: [],
        invoiceData: {},
        ondentData: [],
        infolistData: [],
        importlistData: [],
        resultslistData: [],
        //这里可以设置初始值
        obj:{
          product_code: '',
          model: '',
        },
        content: [],
        showRedBorder:false,
        productcodeIndexList:[],
        modelIndexList:[],
        dialogImageUrl: '',
        pictureDialogVisible: false,
        pictureDialogVisibleB: false,
        pictureDialogVisibleC: false,
        pictureDialogVisibleD: false,
        pictureDialogVisibleE: false,
        pictureDialogVisibleF: false,
        songbai_system: localStorage.getItem('songbai_system'),
        zipFileList: [],
        labelUrl: '',
        errorMessage: '',
        statues: '',
        fileId: '',
        importData: {},
        importFailed: false,
        importWas: false,
        totalFail: false,
        total_success: '',
        total_code: '',
        total_fail: '',
        total_brand: '',
        // productPdfUrl: [],
        zipFileData: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
      this.erpgetdata()
    },
    mounted() {
      this.getParam('ProductType')
      // getSellerInfo()
      //   .then(res => {
      //     if (res.success) {
      //       if (res.content.seller_type==2820||res.content.seller_type==2821) {
      //         this.rules.sale_use_rate[0].required = true
      //       } else {
      //         this.rules.sale_use_rate[0].required = false
      //       }
      //     }
      //   })
      //   .catch(err => {
      //   })
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      checkDate(date) {
        if (/^(\d{4})-(\d{2})-(\d{2})$/.test(date)||/^(\d{4})-(\d{1})-(\d{2})$/.test(date)||/^(\d{4})-(\d{2})-(\d{1})$/.test(date)) {
          return true
        } else {
          return false
        }
      },
      getTreeData(datas) {
        console.log(datas)
        let data = [];
        datas.map((item) => {
          if (item.children.length > 0) {
            let dadax = {
              label: item.text,  //这是需要展示的数据 我的数据是name，所以label对应的是name
              value: item.id,
              sub: this.getTreeData(item.children),
            };
            data.push(dadax);
          } else {
            let dadax = {
              label: item.text,
              value: item.id,
            };
            data.push(dadax);
          }
          return data;
          console.log(data)
        });
        return data;
      },
      uploadFile(file) {
      },
      //处理删除图片功能
      handleProductRemove(file) {
        if (file.id) {
          this.productImgFilesList.forEach((item, index) => {
            if (file.id == item.id) {
              this.productImgFilesList.splice(index, 1);
            }
          })
        } else {
          this.productImageUrl.forEach((item, index) => {
            if (file.uid == item.uid) {
              this.productImageUrl.splice(index, 1);
            }
          })
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.pictureDialogVisible = true;
      },
      handlePictureCardPreviewB(file) {
        this.dialogImageUrl = file.url;
        this.pictureDialogVisibleB = true;
      },
      handlePictureCardPreviewC(file) {
        this.dialogImageUrl = file.url;
        this.pictureDialogVisibleC = true;
      },
      handlePictureCardPreviewD(file) {
        this.dialogImageUrl = file.url;
        this.pictureDialogVisibleD = true;
      },
      handlePictureCardPreviewE(file) {
        this.dialogImageUrl = file.url;
        this.pictureDialogVisibleE = true;
      },
      handlePictureCardPreviewF(file) {
        this.dialogImageUrl = file.url;
        this.pictureDialogVisibleF = true;
      },
      handleCredentialRemove(file) {
        if (file.id) {
          this.productCredentialImgFilesList.forEach((item, index) => {
            if (file.id == item.id) {
              this.productCredentialImgFilesList.splice(index, 1);
            }
          })
        } else {
          this.productCredentialImageUrl.forEach((item, index) => {
            if (file.uid == item.uid) {
              this.productCredentialImageUrl.splice(index, 1);
            }
          })
        }
      },
      handleIntroducePCRemove(file) {
        if (file.id) {
          this.productIntroducePCImgFilesList.forEach((item, index) => {
            if (file.id == item.id) {
              this.productIntroducePCImgFilesList.splice(index, 1);
            }
          })
        } else {
          this.productIntroducePCImageUrl.forEach((item, index) => {
            if (file.uid == item.uid) {
              this.productIntroducePCImageUrl.splice(index, 1);
            }
          })
        }
      },
      handleInstructionsPCRemove(file) {
        if (file.id) {
          this.productInstructionsPCImgFilesList.forEach((item, index) => {
            if (file.id == item.id) {
              this.productInstructionsPCImgFilesList.splice(index, 1);
            }
          })
        } else {
          this.productInstructionsPCImageUrl.forEach((item, index) => {
            if (file.uid == item.uid) {
              this.productInstructionsPCImageUrl.splice(index, 1);
            }
          })
        }
      },
      handleIntroduceAPPRemove(file) {
        if (file.id) {
          this.productIntroduceAPPImgFilesList.forEach((item, index) => {
            if (file.id == item.id) {
              this.productIntroduceAPPImgFilesList.splice(index, 1);
            }
          })
        } else {
          this.productIntroduceAPPImageUrl.forEach((item, index) => {
            if (file.uid == item.uid) {
              this.productIntroduceAPPImageUrl.splice(index, 1);
            }
          })
        }
      },
      handleInstructionsAPPRemove(file) {
        if (file.id) {
          this.productInstructionsAPPImgFilesList.forEach((item, index) => {
            if (file.id == item.id) {
              this.productInstructionsAPPImgFilesList.splice(index, 1);
            }
          })
        } else {
          this.productInstructionsAPPImageUrl.forEach((item, index) => {
            if (file.uid == item.uid) {
              this.productInstructionsAPPImageUrl.splice(index, 1);
            }
          })
        }
      },
      getCouponRule(productName) {
        let param = {
          page: this.productCurrentPage,
          rows: 10,
          attr_name: productName,
        }
        attrList(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.content.rows.length) {
                this.selectedruleName = ''
              }
              this.productAttrs = res.content.rows;
              this.productTotalSize = res.content.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      addProductdialog() {
        this.dialogTitle = '新增商品';
        this.productDialogVisible = true;
        this.productForm.reg_cert_expires = '';
        this.attrValueList = []
        this.activeName = 'first'
        productTree()
          .then(res => {
            if (res.success) {
              this.productOptions = res.content;
            }
          })
          .catch(err => {
          })
        this.getCouponRule();
      },
      editProductdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (localStorage.getItem('songbai_system') == 1) {
          this.isDisable = true
        } else {
          this.isDisable = false
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改商品';
        this.productDialogVisible = true;
        this.activeName = 'first'
        productTree()
          .then(res => {
            if (res.success) {
              this.productOptions = res.content;
            }
          })
          .catch(err => {
          })
        this.detail(this.selectTableData[0].id)
      },
      delProduct() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否确认删除商品？';
        this.$confirm(title, '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          deleteProduct(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      editClassify() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.editSortDialogVisible = true;
        productTree().then(res => {
          if (res.success) {
            this.productOptions = res.content;
          }
        })
          .catch(err => {
          })
        this.sortForm.sort_id = this.selectTableData[0].sort_id3;
        this.productId = this.selectTableData[0].id;
        this.productSortChange(this.selectTableData[0].sort_id3, this.selectTableData[0].brand_id, 'editSort')
      },
      excelData() {
        this.excelDataDialogVisible = true;
        this.excelDataformInline = {
          page: 1,
          rows: 10,
          product_name: "",
          standard_code: "",
          brand: "",
          status: ''
        },
          this.getExcelData(this.excelDataformInline)
      },
      excelDataSearch() {
        this.getExcelData(this.excelDataformInline)
        this.excelDataformInline.page = 1
      },
      sureImport() {
        if (this.selectExcelTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        let arr = [];
        this.selectExcelTableData.forEach((item) => {
          arr.push(item.id)
        })
        this.isCanSubmit = false;
        erpImportProduct(arr)
          .then(res => {
            this.isCanSubmit = true;
            this.loading = false
            if (res.code == -3) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功导入所选商品!'
                });
                this.excelDataDialogVisible = false;
              }
            }
          })
          .catch(err => {
            this.isCanSubmit = true;
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 子公司商品信息同步
      zation() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        this.infoDialogVisible = true;
        this.infoFormInline.product_id = this.selectTableData[0].id;
        this.getInfoData(this.infoFormInline)
      },
      // 获取公司列表
      getInfoData(parameter) {
        this.loading = true
        syncProductList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.infolistData = res.content.rows
              // 分页赋值
              this.infopageparm.currentPage = this.infoFormInline.page
              this.infopageparm.pageSize = this.infoFormInline.rows
              this.infopageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('网络错误，请稍后再试！')
          })
      },
      infocallFather(parm) {
        this.infoFormInline.page = parm.currentPage
        this.infoFormInline.rows = parm.pageSize
        this.getInfoData(this.infoFormInline)
      },
      infoHandleSelectionChange(val) {
        this.infoSelectTableData = val
      },
      // 确认同步
      sureRonous() {
        if (this.infoSelectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        this.id = this.selectTableData[0].id;
        this.product_id = this.infoSelectTableData[0].product_id;
        let parameter = {
          from_product_id: this.product_id,
          to_product_id: this.id,
        }
        syncProduct(parameter)
          .then(res => {
            this.loading = false
            if (res.code == -3) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功从子公司同步商品信息!'
                });
                this.infoDialogVisible = false
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 复制商品信息
      excelCopy(parameter) {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.editCopeDialogVisible = true;
        this.product_name = this.selectTableData[0].product_name;
        this.brand_name = this.selectTableData[0].brand_name;
        this.product_id = this.selectTableData[0].id;
        this.ondentData = [];
        this.showValue = '';
        this.lapeValue = '';
        this.emptyValue = '';
        this.tionsValue = '';
        this.specValue = '';
      },
      addSpecifications(){
        this.ondentData.push(JSON.parse(JSON.stringify(this.obj)))
      },
      // 复制商品信息-确认
      copeMine() {
        let parameter = {

        }
        this.loading = true;
        this.showValue = '';
        this.lapeValue = '';
        this.emptyValue = '';
        this.tionsValue = '';
        this.specValue = '';
        this.productcodeIndexList = [];
        this.modelIndexList = [];
        parameter.product_id = this.product_id;
        parameter.productCopyInfos = this.ondentData;

        // let newArr = this.ondentData.filter((currentValue, currentIndex, sourceArr) =>{
        //   return sourceArr.findIndex(x =>x.product_code === currentValue.product_code)
        // });
        // console.log(newArr);
        copyProduct(parameter)
          .then(res => {
            this.loading = false
            if(res.content) {
              res.content.forEach((item)=>{
                if(item.type=='productCode') {
                  this.productcodeIndexList.push(item.index-1)
                }
                if(item.type=='model') {
                  this.modelIndexList.push(item.index-1)
                }
                if(item.type == "productCode") {
                  this.showValue = true
                }
                if(item.type == "model") {
                  this.lapeValue = true
                }
              })
            }
            if (res.code == -3) {
              this.$message({
                type: 'info',
                message: res.msg
              });
            } else {
              if (res.success == false) {
                if(res.msg == '复制商品信息不能为空') {
                  this.emptyValue = true
                } else {
                  this.emptyValue = false
                };
                if(res.msg == '商品编码不能为空') {
                  this.tionsValue = true
                } else {
                  this.tionsValue = false
                };
                if(res.msg == '型号规格不能为空') {
                  this.specValue = true
                } else {
                  this.specValue = false
                };
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功复制该商品信息!'
                });
                this.getdata(this.formInline)
                this.editCopeDialogVisible = false
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      examineDetail(id) {
        productDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.invoiceData = res.content.productBaseInfo || '';
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
        this.showValue = false
        this.lapeValue = false
      },
      // 获取公司列表
      getExcelData(parameter) {
        this.loading = true
        erpProductList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listExcelData = res.content.rows
              // 分页赋值
              this.excelpageparm.currentPage = this.excelDataformInline.page
              this.excelpageparm.pageSize = this.excelDataformInline.rows
              this.excelpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 提交审核-按钮
      audit(id) {
        const title = '您是否要将商品基础信息提交审核？';
        this.$confirm(title, '提交审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          submitAudit(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '提交审核成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 查看详情-按钮
      lookdetail(id, sortname1, sortname2, sortname3, brand_name) {
        localStorage.setItem('path', '/goods/GoodInfoDetail')
        let tag = {
          url: "/goods/GoodInfoDetail",
          menuname: "商品基础信息详情"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({
          path: '/goods/GoodInfoDetail',
          query: {id: id, sortname1: sortname1, sortname2: sortname2, sortname3: sortname3, brand_name: brand_name}
        })
      },
      detail(id) {
        this.loading = true
        productDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.productForm = res.content.productBaseInfo;
              this.productForm.values = []
              let pics = res.content.pics;
              let video = res.content.vedios;
              let licenses = res.content.licenses;
              if (pics.length) {
                pics.forEach((item) => {
                  this.productImgFilesList.push({
                    url: item.bigpic,
                    id: item.bigpicid
                  })
                })
              }
              if (video.length) {
                video.forEach((item) => {
                  let obj = {
                    video_url: item.video_url,
                    img_url: item.img_url,
                    img_id: item.img_id,
                    isShowButton: false
                  }
                  this.productVideoUrl.push(obj)
                })
              }
              if (licenses.length) {
                licenses.forEach((item) => {
                  this.productCredentialImgFilesList.push({
                    url: item.img_url,
                    id: item.img_id
                  })
                })
              }
              if (Object.keys(res.content.productIntroduceInfo).length) {
                let indroduce = res.content.productIntroduceInfo && res.content.productIntroduceInfo.indroduce;
                let indroduceMobile = res.content.productIntroduceInfo && res.content.productIntroduceInfo.indroduceMobile;
                let use = res.content.productIntroduceInfo && res.content.productIntroduceInfo.use;
                let useMobile = res.content.productIntroduceInfo && res.content.productIntroduceInfo.useMobile;
                if (indroduce.length) {
                  indroduce.forEach((item) => {
                    this.productIntroducePCImgFilesList.push({
                      url: item.img_url,
                      id: item.img_id
                    })
                  })
                }
                if (indroduceMobile.length) {
                  indroduceMobile.forEach((item) => {
                    this.productIntroduceAPPImgFilesList.push({
                      url: item.img_url,
                      id: item.img_id
                    })
                  })
                }
                if (use.length) {
                  use.forEach((item) => {
                    this.productInstructionsPCImgFilesList.push({
                      url: item.img_url,
                      id: item.img_id
                    })
                  })
                }
                if (useMobile.length) {
                  useMobile.forEach((item) => {
                    this.productInstructionsAPPImgFilesList.push({
                      url: item.img_url,
                      id: item.img_id
                    })
                  })
                }
              }
              this.productSortChange(res.content.productBaseInfo.sort_id, res.content.productBaseInfo.brand_id, 'edit', res.content.productBaseInfo.productAttrs)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //获取系统字典
      getParam(type) {
        param(type)
          .then(res => {
            if (res.success) {
              if (type == 'ProductType') {
                this.ProductType = res.content;
              }
            }
          })
          .catch(err => {
          })
      },
      // 修改分类-保存
      sureEditSort() {
        this.sortForm.id = this.productId;
        if (this.productForm.sort_id && typeof (this.productForm.sort_id) != 'string') {
          this.productForm.sort_id = this.productForm.sort_id.pop()
        }
        this.editSortDialogVisible = false
        this.loading = true;
        updateProductSort(this.sortForm)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        productInfoList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      erpgetdata() {
        this.loading = true
        erpImportBtn()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
                if(res.content == true) {
                  this.isshow = true;
                } else {
                  this.isshow = false;
                }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      excelcallFather(parm) {
        this.excelDataformInline.page = parm.currentPage
        this.excelDataformInline.rows = parm.pageSize
        this.getExcelData(this.excelDataformInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      //校验图片
      checkPic(file, type) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.isShowTipMessage = '上传图片仅支持jpg、jpeg、png格式!';
          let that = this;
          if (type == 'isShowTip1') {
            this.isShowTip1 = true;
            setTimeout(function () {
              that.isShowTip1 = false
            }, 5000)
            return false
          } else if (type == 'isShowTip2') {
            this.isShowTip2 = true;
            setTimeout(function () {
              that.isShowTip2 = false
            }, 5000)
            return false
          } else if (type == 'isShowTip3') {
            this.isShowTip3 = true;
            setTimeout(function () {
              that.isShowTip3 = false
            }, 5000)
            return false
          } else if (type == 'isShowTip4') {
            this.isShowTip4 = true;
            setTimeout(function () {
              that.isShowTip4 = false
            }, 5000)
            return false
          } else if (type == 'isShowTip5') {
            this.isShowTip5 = true;
            setTimeout(function () {
              that.isShowTip5 = false
            }, 5000)
            return false
          }
        } else if (!isLt1M) {
          this.isShowTipMessage = '上传图片大小不能超过 1MB!'
          let that = this;
          if (type == 'isShowTip1') {
            this.isShowTip1 = true;
            setTimeout(function () {
              that.isShowTip1 = false
            }, 5000)
            return false
          } else if (type == 'isShowTip2') {
            this.isShowTip2 = true;
            setTimeout(function () {
              that.isShowTip2 = false
            }, 5000)
            return false
          } else if (type == 'isShowTip3') {
            this.isShowTip3 = true;
            setTimeout(function () {
              that.isShowTip3 = false
            }, 5000)
            return false
          } else if (type == 'isShowTip4') {
            this.isShowTip4 = true;
            setTimeout(function () {
              that.isShowTip4 = false
            }, 5000)
            return false
          } else if (type == 'isShowTip5') {
            this.isShowTip5 = true;
            setTimeout(function () {
              that.isShowTip5 = false
            }, 5000)
            return false
          }
        } else {
          return true
        }
        // if (!isJPG) {
        //   this.$message.warning("上传图片仅支持jpg、jpeg、png格式!");
        //   return false
        // } else if (!isLt1M) {
        //   this.$message.warning("上传图片大小不能超过 1MB!");
        //   return false
        // } else {
        //   return true
        // }
      },
      // 商品视频上传
      uploadDefaultUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.warning("上传图片仅支持jpg、jpeg、png格式!");
          return false
        }
        if (!isLt1M) {
          this.$message.warning("上传图片大小不能超过 1MB!");
          return false
        }
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          let width = 500;
          let height = 500;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            let valid = img.width == width && img.height == height;
            valid ? resolve() : reject();
          }
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("file", file);
          // //upload为上传的接口
          // uploadImgTmp(fileData).then(res => {
          //   this.productVideoUrl[this.videoDefaultImgIndex].img_url = res.content
          // }).catch(err => {
          //   this.loading = false
          //   this.$message.error('上传失败，请稍后再试！')
          // })
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.productVideoUrl[this.videoDefaultImgIndex].img_url = res.data.content.file.fileUrl
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          this.$message({
            type: 'warning',
            message: '上传图片的尺寸应为500*500,当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            duration: 2000
          });
          return Promise.reject()
          return false;//必须加上return false; 才能阻止
        })
        return isSize;
      },
      //商品证件上传
      beforeProductCredentialUpload(file) {
        if (this.checkPic(file, 'isShowTip1')) {
          // const fileData = new FormData();
          // fileData.append("file", file);
          // //upload为上传的接口
          // uploadImgTmp(fileData).then(res => {
          //   let data = {
          //     img_id: "",
          //     img_url: res.content
          //   }
          //   this.productCredentialImageUrl.push(data);
          // }).catch(err => {
          //   this.loading = false
          //   this.$message.error('上传失败，请稍后再试！')
          // })
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                let data = {
                  img_id: "",
                  img_url: res.data.content.file.fileUrl
                }
                this.productCredentialImageUrl.push(data);
              })
            }
          });
        } else {
          return false
        }
      },
      //商品介绍PC上传
      beforeProductIntroducePCUpload(file) {
        if (this.checkPic(file, 'isShowTip2')) {
          let imgWidth = ''
          const isSize = new Promise(function (resolve, reject) {
            let width = 1200;
            let _URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = function () {
              imgWidth = img.width
              let valid = img.width == width;
              valid ? resolve() : reject();
            }
            img.src = _URL.createObjectURL(file);
          }).then(() => {
            // const fileData = new FormData();
            // fileData.append("file", file);
            // //upload为上传的接口
            // uploadImgTmp(fileData).then(res => {
            //   let data = {
            //     img_id: "",
            //     img_url: res.content
            //   }
            //   this.productIntroducePCImageUrl.push(data);
            // }).catch(err => {
            //   this.loading = false
            //   this.$message.error('上传失败，请稍后再试！')
            // })
            getToken().then(res => {
              if(res) {
                let result = uploadFile(res,file);
                result.then(res => {
                  let data = {
                    img_id: "",
                    img_url: res.data.content.file.fileUrl
                  }
                  this.productIntroducePCImageUrl.push(data);
                })
              }
            });
            //阻止传到本地浏览器
            return false;
          }, () => {
            // this.$message({
            //   type: 'warning',
            //   message: '上传图片的宽度应为1200,当前上传图片的宽度为：' + imgWidth,
            //   duration: 2000
            // });
            this.isShowTip2 = true;
            this.isShowTipMessage = '上传图片的宽度应为1200,请重新上传图片'
            let that = this;
            setTimeout(function () {
              that.isShowTip2 = false
            }, 5000)
            return Promise.reject()
            return false;//必须加上return false; 才能阻止
          })
          return isSize;
        } else {
          return false
        }
      },
      //商品使用说明PC上传
      beforeProductInstructionsPCUpload(file) {
        if (this.checkPic(file, 'isShowTip3')) {
          let imgWidth = ''
          const isSize = new Promise(function (resolve, reject) {
            let width = 1200;
            let _URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = function () {
              imgWidth = img.width
              let valid = img.width == width;
              valid ? resolve() : reject();
            }
            img.src = _URL.createObjectURL(file);
          }).then(() => {
            // const fileData = new FormData();
            // fileData.append("file", file);
            // //upload为上传的接口
            // uploadImgTmp(fileData).then(res => {
            //   let data = {
            //     img_id: "",
            //     img_url: res.content
            //   }
            //   this.productInstructionsPCImageUrl.push(data);
            // }).catch(err => {
            //   this.loading = false
            //   this.$message.error('上传失败，请稍后再试！')
            // })
            getToken().then(res => {
              if(res) {
                let result = uploadFile(res,file);
                result.then(res => {
                  let data = {
                    img_id: "",
                    img_url: res.data.content.file.fileUrl
                  }
                  this.productInstructionsPCImageUrl.push(data);
                })
              }
            });
            //阻止传到本地浏览器
            return false;
          }, () => {
            // this.$message({
            //   type: 'warning',
            //   message: '上传图片的宽度应为1200,当前上传图片的宽度为：' + imgWidth,
            //   duration: 2000
            // });
            this.isShowTip3 = true;
            this.isShowTipMessage = '上传图片的宽度应为1200,请重新上传图片'
            let that = this;
            setTimeout(function () {
              that.isShowTip3 = false
            }, 5000)
            return Promise.reject()
            return false;//必须加上return false; 才能阻止
          })
          return isSize;
        } else {
          return false
        }
      },
      //商品介绍APP上传
      beforeProductIntroduceAPPUpload(file) {
        if (this.checkPic(file, 'isShowTip4')) {
          let imgWidth = ''
          const isSize = new Promise(function (resolve, reject) {
            let width = 790;
            let _URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = function () {
              imgWidth = img.width
              let valid = img.width == width;
              valid ? resolve() : reject();
            }
            img.src = _URL.createObjectURL(file);
          }).then(() => {
            // const fileData = new FormData();
            // fileData.append("file", file);
            // //upload为上传的接口
            // uploadImgTmp(fileData).then(res => {
            //   let data = {
            //     img_id: "",
            //     img_url: res.content
            //   }
            //   this.productIntroduceAPPImageUrl.push(data);
            // }).catch(err => {
            //   this.loading = false
            //   this.$message.error('上传失败，请稍后再试！')
            // })
            getToken().then(res => {
              if(res) {
                let result = uploadFile(res,file);
                result.then(res => {
                  let data = {
                    img_id: "",
                    img_url: res.data.content.file.fileUrl
                  }
                  this.productIntroduceAPPImageUrl.push(data);
                })
              }
            });
            //阻止传到本地浏览器
            return false;
          }, () => {
            // this.$message({
            //   type: 'warning',
            //   message: '上传图片的宽度应为790,当前上传图片的宽度为：' + imgWidth,
            //   duration: 2000
            // });
            this.isShowTip4 = true;
            this.isShowTipMessage = '上传图片的宽度应为790,请重新上传图片'
            let that = this;
            setTimeout(function () {
              that.isShowTip4 = false
            }, 5000)
            return Promise.reject()
            return false;//必须加上return false; 才能阻止
          })
          return isSize;
        } else {
          return false
        }
      },
      //商品使用说明APP上传
      beforeProductInstructionsAPPUpload(file) {
        if (this.checkPic(file, 'isShowTip5')) {
          let imgWidth = ''
          const isSize = new Promise(function (resolve, reject) {
            let width = 790;
            let _URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = function () {
              imgWidth = img.width
              let valid = img.width == width;
              valid ? resolve() : reject();
            }
            img.src = _URL.createObjectURL(file);
          }).then(() => {
            // const fileData = new FormData();
            // fileData.append("file", file);
            // //upload为上传的接口
            // uploadImgTmp(fileData).then(res => {
            //   let data = {
            //     img_id: "",
            //     img_url: res.content
            //   }
            //   this.productInstructionsAPPImageUrl.push(data);
            // }).catch(err => {
            //   this.loading = false
            //   this.$message.error('上传失败，请稍后再试！')
            // })
            getToken().then(res => {
              if(res) {
                let result = uploadFile(res,file);
                result.then(res => {
                  let data = {
                    img_id: "",
                    img_url: res.data.content.file.fileUrl
                  }
                  this.productInstructionsAPPImageUrl.push(data);
                })
              }
            });
            //阻止传到本地浏览器
            return false;
          }, () => {
            // this.$message({
            //   type: 'warning',
            //   message: '上传图片的宽度应为790,当前上传图片的宽度为：' + imgWidth,
            //   duration: 2000
            // });
            this.isShowTip5 = true;
            this.isShowTipMessage = '上传图片的宽度应为790,请重新上传图片'
            let that = this;
            setTimeout(function () {
              that.isShowTip5 = false
            }, 5000)
            return Promise.reject()
            return false;//必须加上return false; 才能阻止
          })
          return isSize;
        } else {
          return false
        }
      },
      // 商品图片上传
      beforeProductUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.isShowTip = true;
          this.isShowTipMessage = '上传图片仅支持jpg、jpeg、png格式!'
          let that = this;
          setTimeout(function () {
            that.isShowTip = false
          }, 5000)
          return false
        }
        if (!isLt1M) {
          this.isShowTip = true;
          this.isShowTipMessage = '上传图片大小不能超过 1MB!'
          let that = this;
          setTimeout(function () {
            that.isShowTip = false
          }, 5000)
          return false
        }
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          let width = 2000;
          let height = 2000;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            let valid = img.width == width && img.height == height;
            valid ? resolve() : reject();
          }
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("file", file);
          // //upload为上传的接口
          // uploadImgTmp(fileData).then(res => {
          //   let data = {
          //     img_id: "",
          //     uid: file.uid,
          //     img_url: res.content
          //   }
          //   this.productImageUrl.push(data);
          // }).catch(err => {
          //   this.loading = false
          //   this.$message.error('上传失败，请稍后再试！')
          // })
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                let data = {
                  img_id: "",
                  uid: file.uid,
                  img_url: res.data.content.file.fileUrl
                }
                this.productImageUrl.push(data);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          this.isShowTip = true;
          this.isShowTipMessage = '上传图片的尺寸应为2000*2000,请重新上传图片'
          let that = this;
          setTimeout(function () {
            that.isShowTip = false
          }, 5000)
          return Promise.reject()
          return false;//必须加上return false; 才能阻止
        })
        return isSize;
      },
      // 商品视频上传
      beforeUploadVideo(file) {
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (['video/mp4'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的视频格式');
          return false;
        }
        if (!isLt10M) {
          this.$message.error('上传视频大小不能超过10MB哦!');
          return false;
        }
        // const fileData = new FormData();
        // fileData.append("file", file);
        // //upload为上传的接口
        // this.videoloading = true;
        // uploadVideo(fileData).then(res => {
        //   let data = {
        //     img_id: "",
        //     video_url: res.content,
        //     img_url: '',
        //     isShowButton: false
        //   }
        //   this.videoloading = false;
        //   this.productVideoUrl.push(data)
        // }).catch(err => {
        //   this.videoloading = false
        //   this.$message.error('上传失败，请稍后再试！')
        // })
        this.videoloading = true;
        getToken().then(res => {
          if(res) {
            let result = uploadFile(res,file);
            result.then(res => {
              let data = {
                img_id: "",
                video_url: res.data.content.file.fileUrl,
                img_url: '',
                isShowButton: false
              }
              this.videoloading = false;
              this.productVideoUrl.push(data)
            })
          }
        });
      },
      // 商品分类-按钮
      productSortChange(sort_id, brand_id, type, productAttrs) {
        this.$set(this.productForm, "brand_id", "");
        this.$set(this.sortForm, "brand_id", "");
        this.attrValueList = []
        if (type != 'editSort') {
          this.$refs["productForm"].clearValidate(['brand_id']);
        }
        if (type == 'edit') {
          attrValues(sort_id)
            .then(res => {
              if (res.success) {
                //先判断详情里面有没有值，然后根据已有值进行匹配
                if (productAttrs.length) {
                  this.attrValueList = productAttrs;
                } else {
                  this.attrValueList = res.content;
                }
              }
            })
            .catch(err => {

            })
        } else {
          if (sort_id.length) {
            let sordId = sort_id.slice(-1);
            attrValues(sordId)
              .then(res => {
                if (res.success) {
                  this.attrValueList = res.content
                }
              })
              .catch(err => {

              })
          }
        }

        console.log(sort_id)
        if (type == 'edit') {
          productBrand(sort_id)
            .then(res => {
              if (res.success) {
                this.ProductBrandList = res.content;
                this.productForm.brand_id = brand_id;
              }
            })
            .catch(err => {

            })
        } else if (type == 'editSort') {
          productBrand(sort_id)
            .then(res => {
              if (res.success) {
                this.ProductBrandList = res.content;
                this.sortForm.brand_id = brand_id;
              }
            })
            .catch(err => {

            })
        } else {
          if (sort_id.length) {
            let sordId = sort_id.slice(-1);
            productBrand(sordId)
              .then(res => {
                if (res.success) {
                  this.ProductBrandList = res.content;
                }
              })
              .catch(err => {

              })
          }
        }
      },
      checkVideohasImg() {
        for (let i = 0; i < this.productVideoUrl.length; i++) {
          if (this.productVideoUrl[i].img_url == '' || this.productVideoUrl[i].img_url == null || this.productVideoUrl[i].img_url == undefined) {
            return false
          }
        }
      },
      //新增商品-保存
      sureProductsubmit(formName) {
        console.log(this.attrValueList)
        if (this.productForm.sort_id && typeof (this.productForm.sort_id) != 'string') {
          this.productForm.sort_id = this.productForm.sort_id.pop()
        }
        if (!this.checkDate(this.productForm.reg_cert_expires)) {
          this.productForm.reg_cert_expires = timestampToDate(this.productForm.reg_cert_expires)
        }
        if (this.dialogTitle == '修改商品') {
          this.productForm.id = this.productId;
        }
        if (this.checkVideohasImg() == false) {
          this.$message.error('当前有视频没有上传视频缩略图，请上传后再提交')
          return;
        }
        // if (this.productForm.sale_use_rate&&!(/(^[1-9]\d*$)/.test(this.productForm.sale_use_rate))) {
        //   this.$message.error('销售/使用单位比必须是正整数')
        //   return;
        // }
        this.productForm.values = []
        this.attrValueList.forEach((item) => {
          let obj = {
            attr_id: item.attr_id || item.id,
            attr_value: item.attr_value
          }
          this.productForm.values.push(obj)
        })
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增商品') {
              let parameter = {
                productBaseInfo: this.productForm,
                productIntroduceInfo: {
                  indroduce: this.productIntroducePCImageUrl,
                  indroduceMobile: this.productIntroduceAPPImageUrl,
                  use: this.productInstructionsPCImageUrl,
                  useMobile: this.productInstructionsAPPImageUrl,
                },
                licenses: this.productCredentialImageUrl,
                pics: this.productImageUrl,
                vedios: this.productVideoUrl
              }
              addProduct(parameter)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false;
                  if (res.code == -3) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    if (res.success == false) {
                      this.$message({
                        type: 'info',
                        message: res.msg
                      })
                    } else {
                      this.$message({
                        message: '您已成功新增商品基础信息',
                        type: 'success'
                      });
                      this.handleClose()
                      this.getdata(this.formInline)
                    }
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              let productImgFilesList = [];
              this.productImgFilesList.forEach((item) => {
                let obj = {
                  img_id: item.id,
                  uid: '',
                  img_url: item.url
                }
                productImgFilesList.push(obj)
              })
              let productCredentialImgFilesList = [];
              this.productCredentialImgFilesList.forEach((item) => {
                let obj = {
                  img_id: item.id,
                  uid: '',
                  img_url: item.url
                }
                productCredentialImgFilesList.push(obj)
              })
              let productIntroducePCImgFilesList = [];
              this.productIntroducePCImgFilesList.forEach((item) => {
                let obj = {
                  img_id: item.id,
                  uid: '',
                  img_url: item.url
                }
                productIntroducePCImgFilesList.push(obj)
              })
              let productInstructionsPCImgFilesList = [];
              this.productInstructionsPCImgFilesList.forEach((item) => {
                let obj = {
                  img_id: item.id,
                  uid: '',
                  img_url: item.url
                }
                productInstructionsPCImgFilesList.push(obj)
              })
              let productIntroduceAPPImgFilesList = [];
              this.productIntroduceAPPImgFilesList.forEach((item) => {
                let obj = {
                  img_id: item.id,
                  uid: '',
                  img_url: item.url
                }
                productIntroduceAPPImgFilesList.push(obj)
              })
              let productInstructionsAPPImgFilesList = [];
              this.productInstructionsAPPImgFilesList.forEach((item) => {
                let obj = {
                  img_id: item.id,
                  uid: '',
                  img_url: item.url
                }
                productInstructionsAPPImgFilesList.push(obj)
              })
              let parameter = {
                productBaseInfo: this.productForm,
                productIntroduceInfo: {
                  indroduce: this.productIntroducePCImageUrl.concat(productIntroducePCImgFilesList),
                  indroduceMobile: this.productIntroduceAPPImageUrl.concat(productIntroduceAPPImgFilesList),
                  use: this.productInstructionsPCImageUrl.concat(productInstructionsPCImgFilesList),
                  useMobile: this.productInstructionsAPPImageUrl.concat(productInstructionsAPPImgFilesList),
                },
                licenses: this.productCredentialImageUrl.concat(productCredentialImgFilesList),
                pics: this.productImageUrl.concat(productImgFilesList),
                vedios: this.productVideoUrl
              }
              editProduct(parameter)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false;
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      message: '您已成功修改商品基础信息',
                      type: 'success'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            if (this.activeName != 'first') {
              this.$message.error('当前基本信息还有必填项未填写，请检查后再提交！')
            }
          }
        });
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      excelhandleSelectionChange(val) {
        this.selectExcelTableData = val
      },
      //关闭弹窗时的操作
      handleClose() {
        this.$refs["productForm"].resetFields();
        this.$refs.upload1.clearFiles()
        this.$refs.upload2.clearFiles()
        this.$refs.upload3.clearFiles()
        this.$refs.upload4.clearFiles()
        this.$refs.upload5.clearFiles()
        this.$refs.upload6.clearFiles()
        this.$refs.upload7.clearFiles()
        this.productDialogVisible = false;
        this.productImgFilesList = [];
        this.productVideoUrl = [];
        this.productCredentialImgFilesList = [];
        this.productIntroducePCImgFilesList = [];
        this.productInstructionsPCImgFilesList = [];
        this.productIntroduceAPPImgFilesList = [];
        this.productInstructionsAPPImgFilesList = [];
        this.productImageUrl = [];
        this.productVideoUrl = [];
        this.productCredentialImageUrl = [];
        this.productIntroducePCImageUrl = [];
        this.productInstructionsPCImageUrl = [];
        this.productIntroduceAPPImageUrl = [];
        this.productInstructionsAPPImageUrl = [];
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.productName = val;
        this.getCouponRule(val)
      },
      focusRuleName() {
        if (!this.selectedruleName) {
          this.productName = ''
          this.getCouponRule('')
        }
      },
      changeRuleName() {
        this.productCurrentPage = 1
        this.productAttrs.forEach((item) => {
          if (item.id == this.productForm.id) {
            this.selectedruleName = item.attr_name;
            this.getCouponRule(item.attr_name)
          }
        })
      },
      clear() {
        this.getCouponRule()
        this.productCurrentPage = 1
        this.productName = ''
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getCouponRule(this.productName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getCouponRule(this.productName)
      },
      delVideo(i) {
        this.productVideoUrl.forEach((item) => {
          this.productVideoUrl.splice(i, 1)
        })
      },
      handleMouseEnter(isShowButton, i) {
        this.videoDefaultImgIndex = i;
        this.productVideoUrl[i].isShowButton = true;
      },
      handleMouseLeave(isShowButton, i) {
        this.productVideoUrl[i].isShowButton = false;
      },
      // 批量导入基础信息-按钮
      batch() {
        this.importDialogVisible = true;
        this.getImport(this.importFormInline)
      },
      // 获取导入日志列表
      getImport(parameter) {
        this.loading = true
        logsList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.importlistData = res.content.rows
              // 分页赋值
              this.importpageparm.currentPage = this.importFormInline.page
              this.importpageparm.pageSize = this.importFormInline.rows
              this.importpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      importFather(parm) {
        this.importFormInline.page = parm.currentPage
        this.importFormInline.rows = parm.pageSize
        this.getImport(this.importFormInline)
      },
      // 查看结果
      results(file_id, error_message, status, total_fail) {
        this.detailsFormInline.fileId = file_id
        this.summaryFormInline.fileId = file_id
        this.errorMessage = error_message
        this.statues = status
        this.total_fail = total_fail
        if (this.statues == '1') {
          if (this.total_fail == '0') {
            this.totalFail = true
            this.importWas = false
            this.importFailed = false
            this.getDetailsList(this.detailsFormInline)
          } else {
            this.totalFail = false
            this.importWas = true
            this.importFailed = false
            this.getDetailsList(this.detailsFormInline)
            this.getSummaryList(this.summaryFormInline)
          }
        } else if (this.statues == '2') {
          this.totalFail = false
          this.importWas = false
          this.importFailed = true
        }
        this.resultsDialogVisible = true
      },
      // 导入结果明细
      getDetailsList(parameter) {
        this.loading = true
        logsDetailListGroup(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.total_code = res.content.total_code;
              this.total_success = res.content.total_success;
              this.total_fail = res.content.total_fail;
              this.total_brand = res.content.total_brand
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 导入结果明细汇总列表
      getSummaryList(parameter) {
        this.loading = true
        logsDetailList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.resultslistData = res.content.rows
              // 分页赋值
              this.resultspageparm.currentPage = this.summaryFormInline.page
              this.resultspageparm.pageSize = this.summaryFormInline.rows
              this.resultspageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      resultscallFather(parm) {
        this.summaryFormInline.page = parm.currentPage
        this.summaryFormInline.rows = parm.pageSize
        this.getSummaryList(this.summaryFormInline)
      },
      // 确认导入
      confirmImport() {
        if (!this.$refs.zipLoad.uploadFiles || this.$refs.zipLoad.uploadFiles.length === 0) {
          this.$message.error('请上传zip文件');
          return;
        }
        this.isCanSubmit = false
        this.loading = true
        batchImport(this.zipFileData)
          .then(res => {
            this.isCanSubmit = true
            this.loading = false
            if (res.code == -3) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else if (res.code == 0) {
                this.$message({
                  type: 'info',
                  message: '数据正在进行导入，请稍后查看结果！'
                })
                this.getImport(this.importFormInline)
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功导入基础信息'
                });
                this.importHandleClose();
                this.getdata(this.formInline)
              }
            }
          })
          .catch(err => {
            this.isCanSubmit = true
            this.loading = false
            // this.$message.error('网络错误,请稍后再试!')
          })
      },
      // 下载模版
      download(params) {
        this.loading = true;
        baseinfoExport(params)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            let url = window.URL.createObjectURL(new Blob([res]))
            // 插入一个a标签，隐藏，设置href属性，触发点击方法
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', 'importProduct.zip')
            document.body.appendChild(link)
            link.click()
            //下载完成后
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
      },
      // 关闭批量导入基础信息弹窗
      importHandleClose(done) {
        this.$refs.zipLoad.clearFiles();
        this.importDialogVisible = false
        done();
      },
      // 导入zip文件
      beforeUpload(file) {
        const isZip = file.type === 'application/zip' || file.name.endsWith('.zip');
        // const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isZip) {
          this.$message.error('请上传正确的ZIP文件格式');
          return false;
        }
        // if (!isLt10M) {
        //   this.$message.error('上传文件大小不能超过10MB');
        //   return false;
        // }
        const fileData = new FormData();
        fileData.append("file", file);
        this.zipFileData = fileData
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_name == cell.innerText || row.brand_name == cell.innerText || row.product_code == cell.innerText || row.standard_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .flexCenter_box {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mr5 {
    margin-right: 5px;
  }

  .mt30 {
    margin-top: 30px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .keywordTextarea .el-textarea__inner {
    height: 120px;
    width: 500px;
    resize: none;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .productForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 500px;
  }

  /deep/ .productForm .el-input--small {
    width: 500px;
  }

  /deep/ .productForm .el-date-editor.el-input {
    width: 500px;
  }

  /deep/ .sortForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 500px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader {
    height: 152px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  /deep/ .tabs .el-tabs__header {
    width: 312px;
    margin-left: 30%;
  }

  .video-list-box {
    width: 148px;
    height: 148px;
    margin-right: 10px;
    margin-bottom: 20px;
    border-radius: 6px;
    position: relative
  }

  .img-mask {
    width: 100%;
    height: 100%;
    line-height: 148px;
    background: #000;
    opacity: 0.6;
    position: absolute;
    z-index: 99;
    text-align: center;
    border-radius: 6px;
  }

  .img-mask i {
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
  }

  .video-default-img {
    border-radius: 6px;
  }

  .img-tips {
    color: #A8ABB2;
  }

  /deep/ .list-table .el-table__empty-block {
    text-align: inherit;
  }

  /deep/ .tabs .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    height: auto;
  }

  .mt20 {
    margin-top: 20px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .f10 {
    font-size: 10px;
  }

  .f16 {
    font-size: 16px;
  }

  .color666 {
    color: #666666;
  }

  .color409EFF {
    color: #409EFF;
  }

  .colorec808d {
    color: #ec808d;
  }

  .colord9001b {
    color: #d9001b;
  }

  .fw400 {
    font-weight: 400;
  }

  .fw600 {
    font-weight: 600;
  }

  .libel {
    position: relative;
    width: 132px;
    height: 32px;
    line-height: 32px;
    text-align: right;
  }

  .libel:before {
    content: '*';
    position: absolute;
    right: 5px;
    top: 2px;
    color: #F56C6C;
  }

  .billing_item span {
    height: 32px;
    padding-left: 12px;
    padding-right: 15px;
    width: 426px;
    line-height: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .pduct {
    padding: 10px;
    background: #F5F7FA;
    border-radius: 8px;
  }

  /deep/ .el-dialog__title {
    line-height: 20px;
    font-size: 28px;
    font-weight: 600;
    color: #409EFF;
  }

  /deep/ .el-dialog__header {
    padding: 50px 20px 10px;
  }

  .stions {
    border-bottom: 1px solid #EBEEF5;
    padding: 8px 2px;
    text-align: center;
  }

  .scrollbar::-webkit-scrollbar {
    display: none;
  }

  /deep/ .el-result__icon svg {
    width: 24px;
    height: 24px;
  }

  /deep/ .el-result {
    padding: 0;
  }

  .warin {
    width: 24px;
    height: 24px;
  }

  .wari p {
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
    color: #FF5757;
  }
  /deep/ .redBorder input{
    border-color: #F56C6C;
  }

  .prompt {
    font-size: 16px;
    color: #ec808d;
  }

  .importLog {
    font-size: 16px;
    color: #555555;
    font-weight: 700;
    margin: 10px 0;
  }

  .importtion {
    text-align: center;
    padding: 0 20px 20px;
    font-size: 20px;
  }

  .resultent {
    font-size: 20px;
    color: #d9001b;
    margin: 0 0 50px;
  }

  .textCenter {
    text-align: center;
  }

  .icon-container {
    position: relative;
    display: inline-block;
  }

  .icon-container i {
    font-size: 24px;
    position: relative;
  }

  .icon-container i::after {
    content: "上传zip文件";
    width: 100%;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    line-height: 12px;
  }

  .zipFile {
    display: flex;
    align-items: center;
    margin-left: 20%;
  }

</style>





// WEBPACK FOOTER //
// src/views/goods/GoodInfo.vue